import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { startLogin } from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";

const LOGO = "https://customer-assets-jai6qajn.emergentagent.net/job_buildguard-preview/artifacts/3lbt7aob_nirmantra_ai_icon.png";

export default function PublicNav() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();
  const links = [["How It Works", "/#how"], ["NCIS", "/#ncis"], ["Health Report", "/estimate"], ["Verified Partners", "/partners"], ["Advisory Plans", "/plans"]];
  return (
    <header className="backdrop-blur-xl bg-white/80 border-b border-slate-200/60 z-50 sticky top-0">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="public-logo">
          <img src={LOGO} alt="Nirmantra.ai" className="h-9 w-9 rounded-xl object-cover" />
          <span className="font-display font-extrabold text-lg tracking-tight text-slate-900">Nirmantra<span className="text-[#0E9AC8]">.ai</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map(([l, h]) => (
            <a key={l} href={h} className="text-sm font-medium text-slate-600 hover:text-[#0E9AC8] transition-colors">{l}</a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Button onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-button" className="bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white rounded-xl transition-colors">
              <LayoutDashboard className="h-4 w-4 mr-1.5" strokeWidth={1.75} /> Go to Dashboard
            </Button>
          ) : (
            <>
              <Button variant="ghost" onClick={startLogin} data-testid="nav-signin-button" className="text-slate-700 hover:text-[#0E9AC8] rounded-xl">Sign in</Button>
              <Button onClick={startLogin} data-testid="nav-cta-button" className="bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white rounded-xl transition-colors">Get Report</Button>
            </>
          )}
        </div>
        <button className="md:hidden text-slate-700" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-6 py-4 space-y-3">
          {links.map(([l, h]) => (
            <a key={l} href={h} onClick={() => setOpen(false)} className="block text-sm font-medium text-slate-600">{l}</a>
          ))}
          {user ? (
            <Button onClick={() => navigate("/dashboard")} data-testid="nav-dashboard-mobile" className="w-full bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white rounded-xl">Go to Dashboard</Button>
          ) : (
            <Button onClick={startLogin} className="w-full bg-[#0E9AC8] hover:bg-[#0B7EA4] text-white rounded-xl">Get My Report</Button>
          )}
        </div>
      )}
    </header>
  );
}
